module.exports = __webpack_public_path__ + "static/media/hero__no-button.807c0e74.png";